import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import Contact from "./pages/contact";
import Ecommerce from "./pages/ecommerce";
import NotFound from "./pages/NotFound";
import SeoPresentation from "./pages/SeoPresentation";
import SocialReseau from "./pages/socialReseau";
import Application from "./pages/application";
import Graphism from "./pages/graphism";
import SiteVitrine from "./pages/vitrine";
import FAQ from "./pages/Faq";
import LegalMentions from "./pages/LegalMentions";
import TermsConditions from "./pages/GeneralCondition";
import AboutUs from "./pages/AboutUs";

function AppRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/site-e-commerce" element={<Ecommerce />} />
        <Route path="/site-vitrine" element={<SiteVitrine />} />
        <Route path="/seo" element={<SeoPresentation />} />
        <Route path="/reseau-sociaux" element={<SocialReseau />} />
        <Route path="/application-mobile" element={<Application />} />
        <Route path="/conception-graphique" element={<Graphism />} />
        <Route path="/foire-aux-questions" element={<FAQ />} />
        <Route path="/mentions-legales" element={<LegalMentions />} />
        <Route path="/conditions-generales" element={<TermsConditions />} />
        <Route path="/a-propos-de-nous" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} /> {/* 404 */}
      </Routes>
    </Router>
  );
}

export default AppRouter;
